let isIframe = false;
if (window.top != window.self) {
    isIframe = true;
}

class IframeUtils {

    static redirect(url: string) {
        if (isIframe) {
            let message = {type: 'RELOAD_PARENT', url: url};
            window.parent.postMessage(message, "*");
        } else {
            window.location.href = url;
        }
    }

    static notifyUrlChange(url: string) {
        const message = { type: 'URL_CHANGED', url };

        // React Native WebView
        if ((window as any).ReactNativeWebView) {
            (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
            return;
        }

        // Native Android WebView
        if ((window as any).AndroidApp?.notifyUrlChange) {
            (window as any).AndroidApp.notifyUrlChange(url);
            return;
        }

        // Iframe
        if (isIframe) {
            window.parent.postMessage(message, '*');
        }
    }
}

export default IframeUtils;
